var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "ListFilter",
            {
              attrs: {
                FILTER_ITEMS: _vm.FILTER_ITEMS,
                handleSearch: _vm.handleSearch,
              },
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:page:jump:create"],
                      expression: "['admin:page:jump:create']",
                    },
                  ],
                  staticClass: "mr10",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增分享文案")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "60" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "pageTypeName",
                  label: "页面类型",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.pageTypeName ||
                                _vm.getPageTypeName(scope.row.pageType)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "shareText",
                  label: "分享文案",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "coverImage",
                  label: "封面图",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.coverImage
                          ? _c("el-image", {
                              staticStyle: { width: "60px", height: "60px" },
                              attrs: {
                                src: scope.row.coverImage,
                                fit: "cover",
                                "preview-src-list": [scope.row.coverImage],
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appScopeName",
                  label: "关联小程序",
                  "min-width": "140",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.appScope === 1
                                ? _vm.getAppNames(scope.row)
                                : scope.row.appScopeName || "全部"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:page:jump:update:status"],
                              expression: "['admin:page:jump:update:status']",
                            },
                          ],
                          attrs: {
                            value: scope.row.status,
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "开启",
                            "inactive-text": "禁用",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleSwitch(scope.row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "120", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:page:jump:update"],
                                expression: "['admin:page:jump:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:page:jump:delete"],
                                expression: "['admin:page:jump:delete']",
                              },
                            ],
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "text-align": "right", "padding-top": "20px" },
            attrs: {
              "page-sizes": [20, 40, 60, 80],
              "page-size": _vm.pageData.limit,
              "current-page": _vm.pageData.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("PageJumpDialog", {
        attrs: {
          visible: _vm.dialogVisible,
          data: _vm.currentRow,
          loading: _vm.submitLoading,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          submit: _vm.handleSubmit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }